import ToggleInput from "@/components/toggle/Toggle";
import { EditIcon } from "@/constants/utils/svgs";
import { useAppSelector } from "@/hooks/hook";
import { Package } from "@/interfaces/Package";
import { POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import React, { useEffect, useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import { Link } from "react-router-dom";
interface PackageTable {
  packageList: Package[];
}
const PackageTable: React.FC<PackageTable> = ({ packageList }) => {
  const { packageToggle } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
    const [ list, setList] = useState<Package[]>([])
  // toggle cocktail status
  const togglePackage = async (packageId: string, status: boolean) => {
    setList(
        list.map((item: any) => {
          if (item.id === packageId) {
            item.is_active = status;
          }
          return item;
        })
      );
    await POST(
      `${packageToggle}/${packageId}`,
      {
        status,
      },
      refreshToken
    );
  };
 useEffect(()=>{
    setList(packageList)
 },[packageList])
  return (
    <div className="relative overflow-x-auto  rounded-2xl mt-4 overflow-y-auto max-h-full ">
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-xl overflow-hidden">
        <thead className="text-xs text-gray-700 uppercase bg-white border-b ">
          <tr>
            {/* <th scope="col" className="px-2 sm:px-4  py-3">
              Sr#.
            </th> */}
            <th scope="col" className="px-2 sm:px-4  py-3">
              Package Name
            </th>
            <th scope="col" className="px-2 sm:px-4  py-3">
              Type
            </th>
            <th scope="col" className="px-2 sm:px-4  py-3">
              Guest Per Bartender
            </th>
            <th scope="col" className="px-2 sm:px-4  py-3">
              Supplies
            </th>
            <th scope="col" className="px-2 sm:px-4  py-3">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {list.length > 0 &&
            list.map((item, index) => {
              return (
                <tr key={index} className="odd:bg-white even:bg-gray-50 even:border border-l border-r ">
                  {/* <th
                    scope="row"
                    className="px-2 sm:px-4 py-2 font-medium text-gray-900 whitespace-nowrap "
                  >
                    {index + 1}
                  </th> */}
                  <td className="px-2 sm:px-4 py-2 min-w-32  ">{item?.name}</td>
                
                  <td className="px-2 sm:px-4 py-2 capitalize">{item?.type}</td>
                  <td className="px-2 sm:px-4 py-2 w-40">
                    {/* <img className="h-14 w-14 object-cover rounded-full " src={item.image} /> */}
                    {item?.guests_per_bartender}
                  </td>
                  <td className="px-2 sm:px-4 py-2 min-w-48 max-w-[350px]">
                    {item?.supplies.map((data: string) => {
                      return data + " - ";
                    })}
                  </td>
                  <td className="px-2 sm:px-4 py-2">
                    <div className="cursor-pointer flex gap-3 items-center">
                    <ToggleInput
                        // disabled={getCompletion(item) != 100}
                        onChange={() =>
                          togglePackage(item.id, item?.is_active ? false : true)
                        }
                        checked={item.is_active}
                      />
                      <Link
                      to={'/packages/'+item.id}
                      >
                        <div
                          className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                        >
                          <FiEdit2 size={14} />
                        </div>
                      </Link>
                   
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default PackageTable;
